import group from './group/index'

export default function reducer (state = {}, action) {
  return {
    group: group(state.group, action),
  }
}
